import { useEffect } from 'react'

// Subscribes to document visibilitychange and calls back with true (hidden)
// or false (visible). Used by CorendonWidget to pause/resume the conversation
// on mobile background.
export function useVisibilityPause(onChange) {
  useEffect(() => {
    if (typeof document === 'undefined') return
    const handler = () => {
      onChange(document.hidden)
    }
    document.addEventListener('visibilitychange', handler)
    return () => document.removeEventListener('visibilitychange', handler)
  }, [onChange])
}
